// src/components/EventPageSkeleton.jsx
import React from "react";
import { Box } from "@mui/material";

export default function EventPageSkeleton({ backgroundColor = "#f7f7f7" }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: backgroundColor || "#f7f7f7",
        px: 2,
        pt: 2,
        pb: 4,
      }}
    >
      <Box sx={{ maxWidth: 640, mx: "auto" }}>
        {/* Hero placeholder */}
        <Box
          sx={{
            width: "100%",
            aspectRatio: "4 / 3",
            borderRadius: 3,
            backgroundColor: "rgba(0,0,0,0.06)",
          }}
        />

        {/* Title placeholder */}
        <Box
          sx={{
            width: "70%",
            height: 28,
            borderRadius: 999,
            backgroundColor: "rgba(0,0,0,0.06)",
            mx: "auto",
            mt: 2.5,
          }}
        />

        {/* Date/subtitle placeholder */}
        <Box
          sx={{
            width: "42%",
            height: 14,
            borderRadius: 999,
            backgroundColor: "rgba(0,0,0,0.05)",
            mx: "auto",
            mt: 1,
          }}
        />

        {/* Button placeholders */}
        <Box sx={{ display: "flex", gap: 1, mt: 2.5 }}>
          <Box
            sx={{
              flex: 1,
              height: 46,
              borderRadius: 999,
              backgroundColor: "rgba(0,0,0,0.07)",
            }}
          />
          <Box
            sx={{
              flex: 1,
              height: 46,
              borderRadius: 999,
              backgroundColor: "rgba(0,0,0,0.05)",
            }}
          />
        </Box>

        {/* Gallery grid placeholders */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 1,
            mt: 3,
          }}
        >
          {[1, 2, 3, 4].map((x) => (
            <Box
              key={x}
              sx={{
                aspectRatio: "1 / 1",
                borderRadius: 2,
                backgroundColor: "rgba(0,0,0,0.06)",
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}